<template>
  <div class="p-3">
    <form-modal
      ref="modal"
      id="entregaveis"
      placeholder-button="Inserir entregáveis não previstos"
      :fields="colunas"
      :values="dados"
      @ok="salvar"
      @cancel="inicializarForm"
      @edit="editar"
      @remove="remover"
      :titleModal="tituloModal"
      :create="controlesLiberados && permissao.c"
      :read="controlesLiberados && permissao.r"
      :update="false"
      :remove="controlesLiberados && permissao.d"
      :ok-disabled="componente == 'modal-cronograma-etapa'"
      controles
    >
      <template #info-extra> </template>
      <template #buttons="item">
        <div
          v-if="
            item.data.item.aprovado || item.data.item.vinculadoARelatorioEtapa
          "
        >
          <div class="d-flex">
            <div class="align-self-center">
              <b-badge variant="success" v-if="item.data.item.aprovado">
                <i class="fa-solid fa-thumbs-up mr-2"></i>
                Aprovado
              </b-badge>
              <b-button
                variant="outline-primary"
                @click="abrirEtapa(item.data.item.relatorioEtapa)"
                v-if="item.data.item.vinculadoARelatorioEtapa"
              >
                Vinculado à etapa {{ item.data.item.numeroEtapa }}.
              </b-button>
            </div>
            <b-button
              class="ml-2"
              variant="flat-primary"
              @click="download(item.data.item)"
            >
              <i class="fa-solid fa-cloud-download"></i>
            </b-button>
          </div>
        </div>
      </template>
      <template #buttons-prepend="item">
        <b-button
          variant="flat-success"
          @click="editar(item.data)"
          v-if="!item.data.aprovado && controlesLiberados && permissao.u"
        >
          <div v-if="item.data.arquivos.length">
            <i class="fa-solid fa-eye mr-2"></i>
            <span>Ver Produto</span>
          </div>
          <div v-else>
            <i class="fa-solid fa-link mr-2"></i>
            <span>Carregar Produto</span>
          </div>
        </b-button>
        <b-button
          variant="flat-success"
          @click="aprovar(item.data)"
          v-if="
            !item.data.aprovado &&
            liberadoAprovar &&
            permissao.u &&
            item.data.arquivos.length
          "
        >
          <i class="fa-solid fa-thumbs-up mr-2"></i>
          Aprovar
        </b-button>
        <b-button
          class="ml-2"
          variant="flat-primary"
          @click="download(item.data)"
          v-if="item.data.arquivos.length"
        >
          <i class="fa-solid fa-cloud-download"></i>
        </b-button>
        <b-badge
          variant="warning"
          v-if="liberadoAprovar && !item.data.arquivos.length"
        >
          Produto não cadastrado
        </b-badge>
      </template>
      <template #modal>
        <component
          :is="componente"
          ref="form"
          :duracao="projeto.duracao"
          :data-inicio="projeto.dataInicio"
          :form="form"
          :valores="dados"
          :projeto-editavel="controlesLiberados"
          :numero-etapa="form.etapa ? form.etapa.numero : 0 || 0"
          @arquivoSelecionado="onArquivoSelecionado"
          @downloadArquivo="downloadArquivo"
          @removerArquivo="removerArquivo"
        />
      </template>
    </form-modal>
  </div>
</template>
<script>
import FormModal from "@/components/modal/FormModal";

import ProjetoService from "@/common/services/projeto/projeto.service";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

import helpers from "@/common/utils/helpers";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";
import cloneDeep from "lodash/cloneDeep";

import Modal from "./modal.vue";

export default {
  name: "PropostaEntregaveis",
  mixins: [AlertasMixin],
  props: {
    projetoId: {
      type: String,
      required: true,
    },
    projetoIdBase: {
      type: String,
      required: true,
    },
    projeto: {
      type: Object,
      required: true,
    },
    endpoint: {
      type: String,
      required: true,
    },
    projetoEditavel: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FormModal,
    "modal-entregavel": () => import("./modal"),
    "modal-cronograma-etapa": () => import("../cronograma_etapa/modal"),
    Modal,
  },
  data: () => ({
    colunas: [],
    form: [],
    dados: [],
    tituloModal: "",
    componente: "modal-entregavel",
    listaArquivosTemporarios: [],
    ativarAtualizacaoGrade: false,
  }),
  methods: {
    abrirEtapa: function (item) {
      ProjetoService.buscarCronogramaPeloRelatorio(item.id)
        .then((res) => {
          this.form = cloneDeep(res.data.data);
          this.tituloModal = "CRONOGRAMA DE ETAPA";
          this.componente = "modal-cronograma-etapa";
          this.$refs.modal.openModal();
        })
        .catch(() => {
          this.alertaErro("Erro ao buscar");
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    mudarEndpoint: function () {
      if (this.$route.name == "projeto-detalhamento-executora-associada") {
        ProjetoService.setEndpoint("Projeto");
      }
    },
    montar: function () {
      this.buscar();
      this.inicializarColunas();
      this.inicializarForm();
    },
    download: function (item) {
      if (item.vinculadoARelatorioEtapa) {
        let arquivo =
          item.relatorioEtapa.arquivos[item.relatorioEtapa.arquivos.length - 1];
        this.downloadArquivo(arquivo.id);
      } else {
        let arquivo = item.arquivos[item.arquivos.length - 1];
        this.downloadArquivo(arquivo.id);
      }
    },
    downloadArquivo: function (id) {
      this.$store.dispatch(START_LOADING);

      ProjetoService.downloadEntregavel(id)
        .then((response) => {
          helpers.baixarArquivo(response.data, response.headers);
          this.alertaSucesso("Download do Arquivo Concluido!");
        })
        .catch((err) => {
          console.log(err);
          this.alertaErro("Erro ao fazer Download do Arquivo");
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    removerArquivo: function (id) {
      this.confirmar("Aviso", "Deseja remover o arquivo?").then((result) => {
        if (result) {
          this.$store.dispatch(START_LOADING);
          ProjetoService.removerArquivoVersionado(id)
            .then(() => {
              this.alertaSucesso("Arquivo excluído com sucesso!");
              this.buscar();
              this.form[0].arquivos = this.form[0].arquivos.filter(
                (item) => item.id !== id
              );
            })
            .catch(() => {
              this.alertaErro("Erro ao excluir arquivo!");
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        }
      });
    },

    inicializarColunas: function () {
      this.colunas = [
        {
          key: "tipo",
          label: "Tipo",
          formatter: (value, key, item) => {
            if (value)
              return item.vinculadoARelatorioEtapa
                ? `Relatório de etapa`
                : `${helpers.getTipoEntregavel(value).text}`;
          },
        },
        {
          key: "subtipo",
          label: "Produto",
          formatter: (value, key, item) => {
            if (item.vinculadoARelatorioEtapa)
              return item.relatorioEtapa.titulo;

            let tipoEntregavel = helpers.getTipoEntregavel(item.tipo.trim());
            let texto = tipoEntregavel.text;
            if (tipoEntregavel.value != tipoEntregavel.subtipo)
              texto = `${helpers.getEnum(tipoEntregavel.subtipo).text}`;
            return `${texto} ${item.sequencial}`;
          },
        },
        {
          key: "prazo",
          label: "Previsão de entrega",
          formatter: (value, key, item) => {
            let mes = item.vinculadoARelatorioEtapa
              ? item.relatorioEtapa.mesFinal
              : value;
            let nomeMes = this.mesesDepesas.find((el) => el.value == mes);
            return nomeMes ? nomeMes.text : "";
          },
        },
        {
          key: "dataEmissao",
          label: "Data de emissão",
          formatter: (value, key, item) => {
            if (!item.vinculadoARelatorioEtapa && !value) return "";

            if (
              item.vinculadoARelatorioEtapa &&
              !item.relatorioEtapa.dataEmissao
            )
              return "";

            return helpers.formatarDataBr(
              item.vinculadoARelatorioEtapa
                ? item.relatorioEtapa.dataEmissao
                : value
            );
          },
        },
        { key: "actions", label: "Ações", thClass: "text-center" },
      ];
    },
    verificacao: function (item) {
      return !item.vinculadoARelatorioEtapa;
    },

    buscar: function () {
      this.mudarEndpoint();
      ProjetoService.listarGenerico("entregavel", this.projetoIdBase).then(
        (res) => {
          this.dados = res.data.data.sort((a, b) => {
            return (
              (a.vinculadoARelatorioEtapa
                ? a.relatorioEtapa.mesFinal
                : a.prazo) -
              (b.vinculadoARelatorioEtapa ? b.relatorioEtapa.mesFinal : b.prazo)
            );
          });
        }
      );
      ProjetoService.setEndpoint(this.endpoint);
    },

    aprovar: function (item) {
      this.confirmar("Aviso", "Deseja aprovar o entregável?").then((result) => {
        if (result) {
          this.$store.dispatch(START_LOADING);
          this.mudarEndpoint();
          ProjetoService.aprovarEntregavel(item.id)
            .then(() => {
              this.$store.dispatch(STOP_LOADING);
              this.toast(`Entregável aprovado com sucesso`, {
                variant: "success",
                title: "Sucesso",
              });
              this.buscar();
            })
            .catch(() => {
              this.$store.dispatch(STOP_LOADING);
              this.toast(`Erro ao aprovar entregável`, {
                variant: "danger",
                title: "Erro",
              });
            });
          ProjetoService.setEndpoint(this.endpoint);
        }
      });
    },

    upload: function (form) {
      if (form.conteudoBase64 !== null && form.nomeArquivoAWS !== null) {
        this.$store.dispatch(START_LOADING);
        this.mudarEndpoint();
        ProjetoService.uploadEntregavel(form)
          .then(() => {
            this.toast(`Upload realizado com sucesso`, {
              variant: "success",
              title: "Sucesso",
            });
            this.buscar();
          })
          .catch(() => {
            this.toast(`Erro ao realizar upload do entregável`, {
              variant: "danger",
              title: "Erro",
            });
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
        ProjetoService.setEndpoint(this.endpoint);
      }
    },
    onArquivoSelecionado: function (arquivoTemporario) {
      this.listaArquivosTemporarios = [];
      this.listaArquivosTemporarios.push(arquivoTemporario);
    },
    handleAtualizacaoConcluida: function () {
      this.ativarAtualizacaoGrade = false;
    },

    salvar: function () {
      this.confirmar("Aviso", "Deseja salvar os entregáveis?").then(
        (result) => {
          if (result) {
            if (this.$refs.form.validateState() == false) return;
            let form = cloneDeep(this.form);
            const algumEntregavelSemArquivo =
              this.listaArquivosTemporarios.length;

            if (form[0].id && !form[0].arquivos.length) {
              if (algumEntregavelSemArquivo <= 0) {
                this.alertaErro(
                  "Arquivos obrigatórios! Deve ser realizado o upload de pelo menos um arquivo!"
                );
                return;
              }
            }

            this.$store.dispatch(START_LOADING);

            this.listaArquivosTemporarios.forEach((arquivo) => {
              let form = {
                entregavelId: arquivo.entregavelId,
                relatorioEtapaId: null,
                versao: arquivo.versao,
                conteudoBase64: arquivo.conteudoBase64,
                nomeArquivoAWS: arquivo.nomeArquivoAWS,
              };

              ProjetoService.uploadEntregavel(form)
                .then(() => {
                  this.buscar();
                })
                .catch((error) => {
                  console.error("Erro ao salvar o arquivo:", error);
                });
            });
            this.listaArquivosTemporarios = [];

            form.forEach((item, i) => {
              item.indice = i;
              item.projetoId = this.projetoIdBase;
              this.mudarEndpoint();
              if (algumEntregavelSemArquivo >= 0) {
                ProjetoService.salvarEntregavel(item)
                  .then(() => {
                    this.toast(`Entregável salvo com sucesso!`, {
                      variant: "success",
                      title: "Sucesso",
                    });

                    this.form.splice(
                      this.form.indexOf(this.form.find((el) => el.indice == i)),
                      1
                    );
                  })
                  .catch((err) => {
                    if (err.response.status == 400) {
                      this.toast(
                        `Erro ao salvar entregável: ${err.response.data.errors}`,
                        {
                          variant: "danger",
                          title: "Erro",
                        }
                      );
                    } else {
                      this.toast(`Erro ao salvar entregável`, {
                        variant: "danger",
                        title: "Erro",
                      });
                    }
                  })
                  .finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                  });
              }
              ProjetoService.setEndpoint(this.endpoint);
            });
          }
        }
      );
    },

    editar: function (value) {
      let form = cloneDeep(value);
      this.tituloModal = form.vinculadoARelatorioEtapa
        ? `${form.relatorioEtapa.titulo} ${form.relatorioEtapa.numero}`
        : `${helpers.getSubTipoEntregavel(form.subtipo).text} ${
            form.sequencial
          }`;

      this.form = [form];
      this.form[0].entregavelId = this.form[0].id;
      this.componente = "modal-entregavel";
      this.$refs.modal.openModal();
    },

    remover: function (value) {
      this.confirmar("Aviso", "Deseja remover o entregável?").then((result) => {
        if (result) {
          this.$store.dispatch(START_LOADING);

          ProjetoService.removerEntregavel(value.id)
            .then(() => {
              this.alertaSucesso("Entregável excluído com sucesso!");
              this.buscar();
            })
            .catch(() => {
              this.alertaErro("Erro ao excluir entregável!");
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        }
      });
    },

    inicializarForm: function () {
      this.tituloModal = "ENTREGÁVEIS";
      this.form = [
        {
          tipo: "",
          subtipo: "",
          sequencial: 0,
          mesRealizado: 0,
          prazo: 0,
          conteudoBase64: null,
          previsto: false,
        },
      ];
    },
  },
  mounted() {},
  watch: {
    form: {
      handler() {
        if (this.form.length == 0) {
          this.$refs.modal.closeModal();
          this.buscar();
          this.inicializarForm();
        }
      },
      deep: true,
    },
  },
  computed: {
    permissao() {
      return this.$store.getters["app/retornaPermissao"](
        "ProjetosPdEntregaveis"
      );
    },
    mesesDepesas: function () {
      return helpers.criarArrayMes(
        this.projeto.dataInicio,
        this.projeto.duracao
      );
    },
    liberadoAprovar: function () {
      return (
        this.$route.name == "projeto-detalhamento" ||
        this.$route.name == "projeto-detalhamento-proponente-cooperada"
      );
    },
    controlesLiberados: function () {
      return (
        this.$route.name == "projeto-detalhamento-executora-criadora" &&
        this.projetoEditavel
      );
    },
  },
};
</script>
<style lang=""></style>
